// Theme preference for the Admin CMS: 'light' | 'dark' | 'auto'.
//
// 'auto' removes the data-theme attribute so DaisyUI falls back to the
// `default` / `prefersdark` themes declared in stylesheets/application.css
// (i.e. it follows the OS setting). Explicit modes pin data-theme on <html>.

const STORAGE_KEY = 'admin_site_theme'

export const THEME_MODES = [
  { value: 'light', label: 'Light', icon: 'theme_light' },
  { value: 'dark', label: 'Dark', icon: 'theme_dark' },
  { value: 'auto', label: 'Auto', icon: 'theme_auto' }
]

export function loadTheme() {
  if (typeof window === 'undefined') return 'auto'
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return THEME_MODES.some((mode) => mode.value === stored) ? stored : 'auto'
}

export function applyTheme(mode) {
  if (mode === 'auto') {
    document.documentElement.removeAttribute('data-theme')
  } else {
    document.documentElement.setAttribute('data-theme', mode)
  }
}

export function setTheme(mode) {
  window.localStorage.setItem(STORAGE_KEY, mode)
  applyTheme(mode)
}
